module.exports = __webpack_public_path__ + "static/media/WeBananasLogo-horizontal.00b28438.svg";